var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info"},[_c('Nav',{attrs:{"navType":"backnav","textCon":"我要入驻"}}),_c('div',{staticClass:"bottom"},[_c('div',{staticClass:"button",on:{"click":function($event){return _vm.goto()}}},[_vm._v(" 立即申请入驻 ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }